// extracted by mini-css-extract-plugin
export var headerContainer = "CustomPromoBanner-module--header-container--3ce92";